import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizeGuard } from 'src/app/core/guards/authorize.guard';
import { UnloadGuard } from 'src/app/core/guards/unload.guard';
import { AddAddressInformationRequestComponent } from './client-data/add-client-data-request/add-address-request/add-address-request.component';
import { AddAssociatesInformationRequestComponent } from './client-data/add-client-data-request/add-associates-request/add-associates-request.component';
import { AddOwnerInformationRequestComponent } from './client-data/add-client-data-request/add-beneficial-owner-request/add-beneficial-owner-request.component';
import { AddClientDataRequestComponent } from './client-data/add-client-data-request/add-client-data-request.component';
import { AddContactInformationRequestComponent } from './client-data/add-client-data-request/add-contact-information-request/add-contact-information.component';
import { AddLegalInformationRequestComponent } from './client-data/add-client-data-request/add-legal-information-request/add-legal-information-request.component';
import { AddPersonalInformationRequestComponent } from './client-data/add-client-data-request/add-personal-information-request/add-personal-information-request.component';
import { ClientDataRequestDetailsComponent } from './client-data/client-data-details/client-data-details.component';
import { ClientDataListComponent } from './client-data/client-data-list/client-data-list.component';
import { ContractModificationDetailComponent } from './contract-modifications/contract-modification-detail/contract-modification-detail.component';
import { ContractModificationListComponent } from './contract-modifications/contract-modification-list/contract-modification-list.component';
import { ContractModificationWizardComponent } from './contract-modifications/contract-modification-wizard/contract-modification-wizard.component';
import { RequestDetailComponent } from './request-detail/request-detail.component';
import { RequestEntryComponent } from './request-entry/request-entry.component';
import { RequestListComponent } from './request-list/request-list.component';
import { RequestWizardComponent } from './request-wizard/request-wizard.component';
import { RightsGuard } from 'src/app/core/guards/rights.guard';
import { ClientDataRequestPreviewComponent } from './client-data/add-client-data-request/client-data-request-preview/client-data-request-preview.component';
import { RequestRightsGuard } from './request-right.guard';

const routes: Routes = [
  {
    path: 'requests',
    canActivate: [AuthorizeGuard, RightsGuard],
    children: [
      { path: '', component: RequestListComponent },
      { path: 'entry', component: RequestEntryComponent },
      {
        path: 'new',
        component: RequestWizardComponent,
        canActivate: [RequestRightsGuard],
        canDeactivate: [UnloadGuard],
      },
      {
        path: 'client-data',
        children: [
          { path: '', component: ClientDataListComponent },
          {
            path: 'new',
            children: [
              { path: '', component: AddClientDataRequestComponent },
              {
                path: 'personal-information-request',
                component: AddPersonalInformationRequestComponent,
              },
              {
                path: 'contact-information-request',
                component: AddContactInformationRequestComponent,
              },
              {
                path: 'address-information-request',
                component: AddAddressInformationRequestComponent,
              },
              {
                path: 'associates-information-request',
                component: AddAssociatesInformationRequestComponent,
              },
              {
                path: 'owner-information-request',
                component: AddOwnerInformationRequestComponent,
              },
              {
                path: 'legal-information-request',
                component: AddLegalInformationRequestComponent,
              },
              {
                path: 'request-preview',
                component: ClientDataRequestPreviewComponent,
              },
            ],
            canActivate: [RequestRightsGuard],
          },
          { path: ':id', component: ClientDataRequestDetailsComponent },
        ],
      },
      {
        path: 'contract-modifications',
        children: [
          { path: '', component: ContractModificationListComponent },
          {
            path: 'new',
            component: ContractModificationWizardComponent,
            canActivate: [RequestRightsGuard],
            canDeactivate: [UnloadGuard],
          },
          {
            path: 'new/:contractId',
            component: ContractModificationWizardComponent,
            canActivate: [RequestRightsGuard],
            canDeactivate: [UnloadGuard],
          },
          { path: ':id', component: ContractModificationDetailComponent },
        ],
      },
      { path: ':id', component: RequestDetailComponent },
      {
        path: 'new/:contractId',
        component: RequestWizardComponent,
        canDeactivate: [UnloadGuard],
        canActivate: [RequestRightsGuard],
      },
      {
        path: 'new/:contractId/:assetId',
        component: RequestWizardComponent,
        canDeactivate: [UnloadGuard],
        canActivate: [RequestRightsGuard],
      },
      {
        path: 'new/:contractId/:assetId/:requestTypeCode',
        component: RequestWizardComponent,
        canDeactivate: [UnloadGuard],
        canActivate: [RequestRightsGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class RequestsRoutingModule {}
